import React from 'react';
import { useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useFeatureFlagEnabled } from 'src/hooks/useFeatureFlagEnabled';
import { IM_PRICING_GDE_UI_HYBRID_ENABLED } from 'src/util/constants';

type BusinessType = '' | 'Subscription';

type BusinessTypeTabsProps = {
  businessType?: BusinessType;
  onTabChange: (x: BusinessType) => void;
};

export default function BusinessTypeTabs({
  businessType,
  onTabChange,
}: Readonly<BusinessTypeTabsProps>) {
  const translate = useTranslate();
  const isHybridEnabled = useFeatureFlagEnabled(
    IM_PRICING_GDE_UI_HYBRID_ENABLED
  );

  return (
    <Box mb={2} mt={2}>
      <Tabs
        onChange={(
          _event: React.SyntheticEvent,
          selectedItem: BusinessType
        ) => {
          onTabChange(selectedItem);
        }}
        scrollButtons="auto"
        value={businessType ?? ''}
        variant="scrollable"
      >
        {['', 'Subscription'].map((_type) => (
          <Tab
            key={_type}
            label={
              isHybridEnabled
                ? translate(`VendorDeals.BusinessTypeTabforHybrid${_type}`)
                : translate(`VendorDeals.BusinessTypeTab${_type}`)
            }
            value={_type as BusinessType}
            wrapped
          />
        ))}
      </Tabs>
      <Divider />
    </Box>
  );
}
